module.exports = __webpack_public_path__ + "assets/icons/cloud-connector.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/svg/cloud-connector.svg
// module id = xpeM
// module chunks = 1